import { Dispatch, SetStateAction } from "react";
import { Card } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CustomValidationError } from "go-form/services/types";
import {
	CsvImportOverviewFormType,
	ExportCSVTranslationsApi,
	ImportCsvOverviewApi,
	ImportOverviewConfig,
} from "../../../../services/types";
import { AttributeProps } from "../../utils/types";
import { getImportItemsToMap, getMappingsAvailableItems } from "../../utils/utils";
import CsvValuesMappingGroupRows from "./CsvValuesMappingGroupRows";

interface Props {
	form: UseFormReturn<CsvImportOverviewFormType>;
	translations: ExportCSVTranslationsApi;
	importOverviewConfig: ImportOverviewConfig;
	setErrors: Dispatch<SetStateAction<CustomValidationError<CsvImportOverviewFormType>[]>>;
	attributes: AttributeProps[];
	overviewData: ImportCsvOverviewApi;
}

const CsvValuesMappingTable = (props: Props) => {
	const { t } = useTranslation("lib");
	const itemsToMap = getImportItemsToMap(props.overviewData);
	const mappingGroups = Object.keys(itemsToMap);
	const mappingsAvailableItems = getMappingsAvailableItems(props.overviewData);

	if (mappingGroups.length === 0) return null;

	return (
		<Card className="csv-import-value-change-card">
			<Card.Body className="pb-0">
				<table className="table table-form table-with-sticky-header csv-import-value-change-table">
					<thead>
						<tr>
							<th className="action" />
							<th>{t("go_component.field.value_in_csv_file.title")}</th>
							<th>{t("go_component.field.value_in_database.title")}</th>
							<th className="action" />
						</tr>
					</thead>
					<tbody>
						{mappingGroups.map((mappingGroup) => {
							return (
								<CsvValuesMappingGroupRows
									key={mappingGroup}
									mappingGroup={mappingGroup}
									mappingsAvailableItems={mappingsAvailableItems}
									{...props}
								/>
							);
						})}
					</tbody>
				</table>
			</Card.Body>
		</Card>
	);
};

export default CsvValuesMappingTable;
